<template>
  <div>
    <personal-info />
  </div>
</template>

<script>
import PersonalInfo from "./part/personnal-infos"
export default {
  name: "route-personal-data",
  components: {PersonalInfo}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/client/route-personal-data.vue